import React from 'react'
import { Badge } from 'antd'
import { useTranslation } from 'react-i18next'
import { CellSignal, CELL_SIGNAL_STATUS } from '../../utils/mappingLevel'

const SIGNAL_FALLBACK: Record<CellSignal, string> = {
  linked: 'jo linkitetty',
  suggestion: 'ehdotus',
  none: 'ei osumaa'
}

// antd status dot marking a wizard grid cell's state (linked / suggestion / none).
const CellSignalDot: React.FC<{ signal: CellSignal }> = ({ signal }) => {
  const { t } = useTranslation()
  return (
    <span title={t(`groupCustomerMapping:cellSignal-${signal}`, SIGNAL_FALLBACK[signal])}>
      <Badge status={CELL_SIGNAL_STATUS[signal]} style={{ marginRight: 6 }} />
    </span>
  )
}

export default CellSignalDot
